import React from 'react';
import './Mision.css';
import misionFoto from '../Imagenes/mision_foto.jpeg';

const Mision = () => (
  <main className="mision-page">
    <section className="mision-hero" style={{ backgroundImage: `url(${misionFoto})` }}>
      <div className="mision-hero-overlay" />
      <div className="mision-container mision-hero-content reveal-on-scroll">
        <h1>Mision</h1>
        <p>
          Compromiso institucional con la planificacion y gestion sustentable de los recursos
          hidricos de la provincia.
        </p>
      </div>
    </section>

    <section className="mision-content">
      <div className="mision-container mision-cards single">
        <article className="mision-card reveal-on-scroll">
          <p>
            Planificar, estudiar, proyectar y ejecutar Obras Hidráulicas, y acciones referentes a la preservación de la cuenca hídrica, regularización y fiscalización del uso de las aguas superficiales y subterráneas, excepto las destinadas al uso de riego e industria, dentro del ámbito Provincial, para su aprovechamiento en un desarrollo sustentable y protección de inundaciones.
          </p>
        </article>
      </div>
    </section>
  </main>
);

export default Mision;

